import React from "react";
import { MatApoyo } from "../Generals";

export default function Lesson6({ idLesson, data, setLoading }) {
  return (
    <div className="texto_parrafo">
      <p>Las causales de nulidad de la votación a nivel federal se establecen en el artículo 75 de la Ley General del Sistema de 
        Medios de Impugnación en Materia Electoral, lo cual te explicamos en el siguiente video.
      </p>
      {data && data.indexOf(0) && <MatApoyo array={[data[0]]} />}<br/><br/>
      <p>
        Para repasar la información te invitamos realizar la siguiente actividad: 
      </p>
      {data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}<br/><br/>
      <p>
        ¿Sabes qué son los medios de impugnación? 
      </p>
      <p>
        Son el conjunto de <b>recursos y juicios</b> que tienen derecho a interponer las y los ciudadanos, los partidos políticos y las 
        candidaturas independientes en contra de los actos y resoluciones de las autoridades electorales, cuando éstos, a criterio 
        de quienes se inconforman, presentan deficiencias o errores.
      </p>
      <p>
        Los medios de impugnación sirven para <b>modificar, revocar o anular</b> los actos y las resoluciones en materia electoral que no 
        se apeguen a las normas jurídicas.
      </p>
      <p>
        A nivel federal, estos recursos se encuentran previstos en la Ley General del Sistema de Medios de Impugnación en Materia Electoral
        y se resuelven ante el Tribunal Electoral del Poder Judicial de la Federación. Revisa el siguiente material para conocerlos.
      </p>
      {data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}
      <p>
        Para profundizar en los temas de medios de impugnación a nivel local consulta el <b className="textoResaltado2"> CAPÍTULO 6 DE TU {data && data.indexOf(4) && <MatApoyo array={[data[4]]} tipo={1} />}</b> que se 
        encuentra disponible en los materiales de consulta de este curso. 
      </p>
      <p>
        A continuación, revisa el siguiente material de apoyo para reforzar lo que aprendiste.
      </p>
      {data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}
      <p>
        A continuación, realiza la actividad autoevaluable correspondiente para continuar con la siguiente lección.
      </p>
    </div>
  );
}
